var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClinicalPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "78px",
    viewBox: "0 0 84 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clinical-partners") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clinical-partners",
    transform: "translate(0.249759, 0.154168)",
    fill: "#132735",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.9432414,7.62683229 C71.2002414,2.88283229 64.8652414,0.178832286 58.1062414,0.0118322857 C52.1192414,-0.134167714 46.4532414,1.67283229 41.7232414,5.24483229 C37.0072414,1.68483229 31.3552414,-0.126167714 25.3812414,0.00683228567 C18.6122414,0.160832286 12.2632414,2.86683229 7.50324135,7.62583229 C2.35724135,12.7728323 -0.163758646,18.6168323 0.0082413545,24.9978323 C0.450241354,41.3468323 18.4842414,57.5318323 31.6582414,69.3538323 C34.7362414,72.1158323 37.6442414,74.7248323 39.8212414,76.9028323 C40.3292414,77.4108323 41.0052414,77.6908323 41.7232414,77.6908323 C42.4422414,77.6908323 43.1182414,77.4108323 43.6252414,76.9028323 C46.0272414,74.5008323 49.0662414,71.7508323 52.2842414,68.8398323 C58.9082414,62.8478323 66.4152414,56.0558323 72.4512414,48.7458323 C79.7012414,39.9648323 83.3132414,32.1928323 83.4932414,24.9848323 C83.6522414,18.6358323 81.1122414,12.7958323 75.9432414,7.62683229 Z M23.8762414,43.4608323 L23.8762414,29.8518323 L34.9462414,29.8518323 L34.9462414,18.7818323 L48.5552414,18.7818323 L48.5552414,29.8518323 L59.6242414,29.8518323 L59.6242414,43.4598323 L48.5542414,43.4598323 L48.5542414,54.5298323 L34.9452414,54.5298323 L34.9452414,43.4598323 L23.8762414,43.4598323 L23.8762414,43.4608323 Z",
    id: "Shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalPartners);
export default __webpack_public_path__ + "static/media/clinical-partners.bdd731a9438b191a29066e6d79b94f1b.svg";
export { ForwardRef as ReactComponent };